// CE Magnifique Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // === MOBILE MENU ===
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.contains('open');
      mobileMenu.classList.toggle('open');
      hamburger.classList.toggle('active');
      hamburger.setAttribute('aria-expanded', String(!isOpen));
    });

    mobileMenu.querySelectorAll('.mobile-nav-link').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // === FAQ ACCORDION ===
  document.querySelectorAll('.faq-question').forEach(function (question) {
    question.addEventListener('click', function () {
      var answer = this.nextElementSibling;
      var isActive = this.classList.contains('active');

      document.querySelectorAll('.faq-question').forEach(function (q) {
        q.classList.remove('active');
        if (q.nextElementSibling) {
          q.nextElementSibling.style.maxHeight = null;
        }
      });

      if (!isActive) {
        this.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // === HEADER SCROLL ===
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        header.style.background = 'rgba(10,10,10,1)';
        header.style.borderBottomColor = 'rgba(204,0,0,0.35)';
      } else {
        header.style.background = 'rgba(10,10,10,0.97)';
        header.style.borderBottomColor = 'rgba(204,0,0,0.2)';
      }
    }, { passive: true });
  }

  // === IMAGE ERROR FALLBACK ===
  document.querySelectorAll('.work-img, .gallery-img').forEach(function (img) {
    img.addEventListener('error', function () {
      var filename = this.dataset.filename || this.src.split('/').pop().split('?')[0];
      var parent = this.closest('.gallery-item, .work-item');
      if (parent) {
        var placeholder = document.createElement('div');
        placeholder.className = 'img-placeholder';
        placeholder.innerHTML = 'Upload <strong>' + filename + '</strong> to your theme assets folder';
        parent.replaceChild(placeholder, this);
      }
    });
  });

  // === SMOOTH SCROLL FOR ANCHOR LINKS ===
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var headerH = header ? header.offsetHeight : 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

});
